import React from 'react'
import { Trans } from 'react-i18next'
import BenzemaTimer from '../../../medium/profil-banner/benzema-timer/BenzemaTimer'
import EarlyBirdCustomSectionProps from './EarlyBirdCustomSectionProps'
import BenzemaBanner from 'components/icons/BenzemaClub/custom_profil/Banner-asset.webp';
import BenzemaGift from 'components/icons/BenzemaClub/custom_profil/icons/gift.webp';
import BenzemaLegendLeague from 'components/icons/BenzemaClub/custom_profil/icons/legendleague.webp';
import BenzemaPackCards from 'components/icons/BenzemaClub/custom_profil/icons/pack4cards.webp';
import BenzemaStonk from 'components/icons/BenzemaClub/custom_profil/icons/stonks.webp';
import BenzemaTeam from 'components/icons/BenzemaClub/custom_profil/icons/team.webp';
import './style.scss';
import { NUMBER_OF_FREE_CARDS, NUMBER_OF_FREE_CARDS_ONBOARDING } from 'config/_const';
import Application from 'Application';

const EarlyBirdCustomSection: React.FC<EarlyBirdCustomSectionProps> = ({ assetViewModel, isPrimaryMarketWillStart, setPreSaleIsOpen, setPrivateSellIsOpen }) => {
    const nbTokens = !Application.getInstance().OnBoardingV2 ? NUMBER_OF_FREE_CARDS : NUMBER_OF_FREE_CARDS_ONBOARDING;
    
    return (
        <div className="early-bird-custom-section">
            <div className='banner-container'>
                <div className='asset-profil-header-img-container'>
                    <img src={BenzemaBanner} alt='Benzema banner' />
                    <span className="benzema-page-title"><Trans i18nKey="benzema.custom-profil.banner.text.1" ></Trans></span>
                </div>
                <div className='lists-benefits-container'>
                    <span><Trans i18nKey="benzema.custom-profil.banner.benefits.text.1" /></span>
                    <div className='lists-benefits-container__content'>
                        <div className='text'><img src={BenzemaTeam} className='icon' /><span><Trans i18nKey="benzema.custom-profil.banner.benefits.list.1" /></span></div>
                        <div className='text'><img src={BenzemaLegendLeague} className='icon' /><span><Trans i18nKey="benzema.custom-profil.banner.benefits.list.2" /></span></div>
                        <div className='text'><img src={BenzemaStonk} className='icon' /><span><Trans i18nKey="benzema.custom-profil.banner.benefits.list.3" /></span></div>
                        <div className='text'><img src={BenzemaPackCards} className='icon' /><span><Trans i18nKey="benzema.custom-profil.banner.benefits.list.4" values={{ nbTokens: nbTokens }}/></span></div>
                        <div className='text'><img src={BenzemaGift} className='icon' /><span><Trans i18nKey="benzema.custom-profil.banner.benefits.list.5" /></span></div>
                    </div>
                </div>
            </div>
            <div className='timer-container'>
                <span><Trans i18nKey="benzema.custom-profil.banner.timer.text.1" /></span>
            </div>

            {isPrimaryMarketWillStart && <div className="benzema-timer-container">
                <BenzemaTimer setPreSaleIsOpen={setPreSaleIsOpen} setPrivateSellIsOpen={setPrivateSellIsOpen} assetVM={assetViewModel} />
            </div>}
        </div>
    )
}

export default EarlyBirdCustomSection;
